import React from 'react'
import ReactMarkdown from 'react-markdown'

import * as check from './check'

/**
 * Most rows in the compatibility table are of
 * of the form 'Text' 'Icon status' 'Message'
 *
 * That's what encapsulates in a component.
 */
export default class CheckRow extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      status: check.status.warning,
      resultMarkdown: ''
    }
    this.runCheck(props.checkFeature())
  }

  runCheck (checkFeature) {
    checkFeature.then(result => {
      this.setState({
        status: result.status,
        resultMarkdown: result.text
      })
    })
  }

  render () {
    const {checkFeature, name} = this.props,
          {status, resultMarkdown} = this.state

    return (
      <tr>
        <td>{name}</td>
        <check.Check status={status} />
        <td colSpan={'2'}>
          <ReactMarkdown source={resultMarkdown} />
        </td>
      </tr>
    )
  }
}


// WEBPACK FOOTER //
// ./app/check-row.js